import { type FC } from 'react';

import { useSelector } from '@hh.ru/front-static-app';
import { Card, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';

import Header from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard/Header';
import MultiStepForm from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard/MultiStepForm';
import ApplicantLoginProvider from 'src/components/AccountLogin/CombinedLoginCards/ApplicantLoginCard/context';

const skipAccountTypeStepBackUrls = ['oauth', 'dev.hh.ru'];

const ApplicantLoginCard: FC = () => {
    const backUrl = useSelector((state) => state.authUrl?.backurl);
    const { isGtXS } = useBreakpoint();

    const shouldSkipAccountTypeSelection = skipAccountTypeStepBackUrls.some((url) => backUrl?.includes(url));

    return (
        <Card
            borderWidth={isGtXS ? 'default' : 'none'}
            stretched
            padding={24}
            borderRadius={40}
            data-qa="applicant-login-card"
        >
            <ApplicantLoginProvider
                initialStep={shouldSkipAccountTypeSelection ? 'enter-credentials' : 'account-type-selection'}
                initialFlow={shouldSkipAccountTypeSelection ? 'sign-in' : null}
            >
                <Header />
                <VSpacing default={24} />
                <MultiStepForm />
            </ApplicantLoginProvider>
        </Card>
    );
};

export default ApplicantLoginCard;
